import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { Quiniela } from 'src/app/models/quiniela';
import html2canvas from 'html2canvas';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';


@Component({
  selector: 'app-compartir-page',
  templateUrl: './compartir-page.component.html',
  styleUrls: ['./compartir-page.component.css']
})
export class CompartirPageComponent implements OnInit {
  quiniela: Quiniela;
  isLoading = false;
  dominio = window.location.origin;
  pageLink = "";
  pageTitle = "";

  constructor(
    private rutaActiva: ActivatedRoute,
    private QuinielasService: QuinielasService,
    private toastr: ToastrService,
  ) { }


  ngOnInit(): void {
    // Obtener por parametro de URL el ID de la Quiniela
    var idQuiniela = this.rutaActiva.snapshot.params.id;

    // Obtener la Quiniela con ese ID mediante el Servicio
    this.QuinielasService.getQuiniela(idQuiniela).subscribe((item) => {
      this.quiniela = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
      // Imprimiendo la Quiniela
      console.log(this.quiniela)
      this.pageLink = this.dominio + "/" + this.quiniela.url;
      this.pageTitle = "⚽ Entra y juega en la quiniela: " + this.quiniela.titulo + ".";
    });
  }

  copiarAlPortapapelesURL() {

    var enlaceQuiniela = this.dominio + "/" + this.quiniela.url

    // Crea un campo de texto "oculto"
    var aux = document.createElement("input");

    // Asigna el contenido del elemento especificado al valor del campo
    aux.setAttribute("value", enlaceQuiniela);

    // Añade el campo a la página
    document.body.appendChild(aux);

    // Selecciona el contenido del campo
    aux.select();

    // Copia el texto seleccionado
    document.execCommand("copy");

    // Elimina el campo de la página
    document.body.removeChild(aux);

    // Enviar el Alerta
    this.toastr.success('¡Se ha copiado a portapapeles el enlace para compartir!');

  }

  Futbolista: AnimationOptions = {
    path: '/assets/img/futbolista.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

  takeshot() {
    // Ocultar el Icono que se miestra antes de Genera la Imagen
    document.getElementById('Icono').style.display = "none";
    document.getElementById('BotonGenerar').style.display = "none";
    document.getElementById('AlertaImagen').style.display = "block";

    // Obteniendo el DIV de la vista
    let div = document.getElementById('photo');
    // Haciendo visible el DIV para posteriormente tomar captura del mismo
    div.style.display = "block";
    // Se espera unos milisegundos para que el DIV se haga visible
    setTimeout(() => {
      // Hacinedo la Captura
      html2canvas(div).then(
        function (canvas) {
          document
            .getElementById('output')
            .appendChild(canvas);
        })
      // Ocultando DIV usando para la Foto
      div.style.display = "none";
    }, 25);

  }

  fbs_click(): void {
    window.open(`http://www.facebook.com/sharer.php?u=${this.pageLink}&quote=${this.pageTitle}`, 'sharer', 'toolbar=0,status=0,width=626,height=436');
  }

  tbs_click(): void {
    window.open(`https://twitter.com/intent/tweet?text=${this.pageTitle}&url=${this.pageLink}`, 'sharer', 'toolbar=0,status=0,width=626,height=436');
  }

}
